import React from "react";
import { connect } from "react-redux";
import { Grid } from "semantic-ui-react";

const CountModalSummary = (props) => {
  const { min, pos, game, site, countDate } = props.data;
  return (
    <Grid columns={2}>
      <Grid.Row>
        <Grid.Column width={4} className="font-bold">
          Site:
        </Grid.Column>
        <Grid.Column>{site}</Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={4} className="font-bold">
          Count Date:
        </Grid.Column>
        <Grid.Column>{countDate}</Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={4} className="font-bold">
          Position:
        </Grid.Column>
        <Grid.Column>{pos}</Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={4} className="font-bold">
          Game:
        </Grid.Column>
        <Grid.Column>{game}</Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={4} className="font-bold">
          MIN:
        </Grid.Column>
        <Grid.Column>{min}</Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    data: state.editMachineCountModal,
  };
};

export default connect(mapStateToProps)(CountModalSummary);
